import React from "react";
import { Remarkable } from "remarkable";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { GlobalStore } from "../../stores/global";
import Link from "../global/link";
const markdown = new Remarkable({ html: true });

export function RichText({ className = "", data }) {
  return <div className={`blogRichText ${className}`} dangerouslySetInnerHTML={{ __html: markdown.render(data) }} />;
}

export function Caption({ data }) {
  return <div className="blogCaption" dangerouslySetInnerHTML={{ __html: markdown.render(data) }} />;
}

export function TwoColumns({ dataLeft, dataRight }) {
  return (
    <div className="blogTwoColumns">
      <RichText data={dataLeft} />
      <RichText data={dataRight} />
    </div>
  );
}

export function Video({ className = "", data }) {
  return (
    <>
      <h3 className="videoTitle" dangerouslySetInnerHTML={{ __html: markdown.render(data.title) }} />
      <RichText className="videoText" data={data.video_text} />
      <div className={`blogVideo ${className}`}>
        <video controls>
          <source src={data.video?.url} type={data.type} />
        </video>
      </div>
    </>
  );
}

export function WideImage({ className = "", src, alt }) {
  return (
    <div className={`blogWideImage ${className}`}>
      <LazyLoadImage src={src} alt={alt} effect="blur" />
    </div>
  );
}

export function TextImage({ data }) {
  const {
    Content,
    Image: { url, alternativeText }
  } = data;
  return (
    <div className="blogTextImage">
      <RichText data={Content} className="content" />
      <div className="image">
        <LazyLoadImage src={url} alt={alternativeText} />
      </div>
    </div>
  );
}

export function ImageText({ data }) {
  data.Image = data.Image || {};
  const {
    Content,
    Image: { url, alternativeText }
  } = data;
  return (
    <div className="blogTextImage">
      <div className="image">
        <LazyLoadImage src={url} alt={alternativeText} />
      </div>
      <RichText data={Content} className="content" />
    </div>
  );
}

export function MiniCta({ content }) {
  const { currentCountryCode: countryCode } = GlobalStore.useState(c => c);
  const { header, booknow, booknowlink, downloadappcaption, downloadapplink } = content;

  const gotoBookNow = () => {
    if (booknowlink) {
      window.location.href = booknowlink.toLowerCase().replace(/:country/, countryCode.toLowerCase());
    } else {
      window.scrollTo({ behavior: "smooth", left: 0, top: 0 });
    }
  };

  return (
    <div id="miniCta">
      <div className="wrap">
        <div className="header">{header}</div>
        <div className="btnContainer">
          <div className="btn primary" onClick={gotoBookNow}>
            <span>{booknow}</span>
          </div>
          {downloadappcaption && downloadapplink && (
            <div className="btn secondary">
              <Link
                link={downloadapplink && downloadapplink.toLowerCase().replace(/:country/, countryCode.toLowerCase())}
                text={
                  <>
                    <span>{downloadappcaption}</span>
                  </>
                }
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
